// extracted by mini-css-extract-plugin
export default {"table-header-cell":"TableHeader_table-header-cell__PJB6P"};